import { Notification } from '../Notifications';

export type GroupedNotifications = {
  [key: string]: Notification[];
};

/**
 *
 * groupNotifications
 *
 * Groups notifications by batchID so that they can be displayed as a single
 * item instead of multiple items i.e. You have received 5 messages instead of 5
 * different notification entries for the same
 *
 */
export default function groupNotifications(
  notifications: Notification[],
): GroupedNotifications {
  const groupedNotifications: GroupedNotifications = {};
  notifications.forEach((notification) => {
    const groupByKeyword = `${notification.userBatchID}_${notification.serviceBatchID}`;
    if (!groupedNotifications[groupByKeyword]) {
      groupedNotifications[groupByKeyword] = [];
    }
    groupedNotifications[groupByKeyword].push(notification);
  });
  return groupedNotifications;
}
